import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import "./Contact.css";
import emailjs from '@emailjs/browser';
import { useRef } from 'react';
import { toast } from 'react-hot-toast';

const Contact = () => {

    const formInfo = useRef();

    const handelSubmit = (e) => {
        e.preventDefault();
        const form = e.target;

        emailjs.sendForm('service_zpr5xzc', 'template_qyzn5gx', formInfo.current, 't9cun8c2GFCB6cJBC')
            .then(() => {
                toast.success("Your message sucessgully");
                form.reset();
            }, (error) => { });
    }

    return (
        <div>
            <Header></Header>
            <div className='main-contact flex flex-col justify-between px-2'>
                <div className='contact mt-16 md:mt-32 lg:mt-32 mx-auto'>
                    <p className='text-center text-xl uppercase font-bold text-[orange]'>Contact with me</p>
                    <div className='contact-form mt-2'>
                        <form ref={formInfo} onSubmit={(e) => handelSubmit(e)}>
                            <input type='text' required name='name' placeholder='Enter Your Name'></input>
                            <input type='email' required name='email' placeholder='Enter Your Email'></input>
                            <input type='number' required name='number' placeholder='Enter Your Number'></input>
                            <textarea className='h-24' type='text' required name='message' placeholder='Message'></textarea>
                            <div className='text-center mt-2'>
                                <button className='btn uppercase'>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        </div>
    );
};

export default Contact;